import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csliteral(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# literals tutorial For Beginners</title>
 <meta name="description" content="C# literals tutorial for beginners.literals in C# is also known as constants,literal depends upon its type CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# literals,c# literals for,c sharp literals,Constants in C#,C# Literal Types" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-literal" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Literals in C#</h1>
    <div className="first">
        <a href="/csharp-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-namespace">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-What is literals in C#?</h2>
   <p className="mt-4 para"> <span className="bold">Answer</span>-those value fixed to a variable and refer to fixed values. This is known as<span className="bold"> Literals in C#</span>.</p>
   <p className="mt-4 para">1, literal is also known as constants<br/>
2, literal depends upon its type<br/>
3, C# literals have any type of primitive data types<br/>
</p>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-4">code</span>
            <span className="qwerty-3"> exampler</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-4">is</span>
              <span className="qwerty-3"> a </span>
            <span className="qwerty-2">data_types</span>
            {"\n"}
            <span className="qwerty-5">A</span>
            <span className="qwerty-2"> is a</span>
            <span className="qwerty-6"> variable</span>
            {"\n"}
            <span className="qwerty-4">= </span>
            <span className="qwerty-2">is an </span>
            <span className="qwerty-3">operato</span>
            {"\n"}{"\n"}
            <span className="qwerty-4">Code</span>
            <span className="qwerty-3"> exampler </span>
            <span className="qwerty-2">is a </span>
            <span className="qwerty-3">c# </span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-5">literal</span>
            {"\n"} {"\n"}
        
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">There are many types of Literals in c#:<br/>
</h2>
<h3  className="mt-4 mh3">1, String Literals<br/>
2, integer literals<br/>
3, float literals<br/>
4, character literals<br/>
5, Boolean literals<br/>
6, null literals
</h3>
<h2 className="mt-4 mh2">1, String literal in c#: <br/></h2>


<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">literals</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">class </span>
            <span className="qwerty-3">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">static </span>
            <span className="qwerty-3">void</span>
            <span className="qwerty-2"> Main</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-2">string </span>
            <span className="qwerty-5">[] </span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
              <span className="qwerty-10">string</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-5">Hello</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">string </span>
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty">Ram</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-11">  Or </span>
            {"\n"} 
            <span className="qwerty-4"> String </span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-5">, </span>
              <span className="qwerty-3">b</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-5">Hello</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty">Ram</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
              <span className="qwerty-5"> WriteLine</span>
              <span className="qwerty-2">(</span>
              <span className="qwerty-3">a</span>
            <span className="qwerty-2">+" "+</span>
            <span className="qwerty">b</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"}
              <span className="qwerty-5">Hello </span>
              <span className="qwerty">Ram</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>



<h2 className="mt-4 mh2">2, Integer literal in c#:</h2>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"} 
              <span className="qwerty-10">int</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-5">10</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-10">int </span>
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty">20</span>
            <span className="qwerty-2">";</span>
            {"\n"}   {"\n"}
            <span className="qwerty-11">  Or </span>
            {"\n"}    {"\n"}
            <span className="qwerty-4"> int </span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-5">, </span>
              <span className="qwerty-3">b</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-5">10</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-3">b </span>
            <span className="qwerty-2">= "</span>
            <span className="qwerty">20</span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-4"> Console.</span>
              <span className="qwerty-5"> WriteLine</span>
              <span className="qwerty-2">(</span>
              <span className="qwerty-3">a</span>
            <span className="qwerty-2">+" "+</span>
            <span className="qwerty">b</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-2">;</span>
          {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"}
              <span className="qwerty-5">10 </span>
              <span className="qwerty">20</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h2 className="mt-4 mh2">3, float literals in c#:</h2>

   <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}  {"\n"}
              <span className="qwerty-10">float</span>
            <span className="qwerty-3"> a</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-2">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-11">Or </span>
            {"\n"}  
            <span className="qwerty-10">double </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty">b</span>
            {"\n"} {"\n"}
            <span className="qwerty-11">Or </span>
            {"\n"} 
            <span className="qwerty-4">float </span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-5">, </span>
              <span className="qwerty-10">double </span>
              <span className="qwerty-3">b</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5">400.8206</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty">40.25</span>
            <span className="qwerty-2">f</span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">4, Character literals in c#-</h2>



<h2 className='headings'>Q-Using charAt() method example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
  
            <span className="qwerty-5">String </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-4">d</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Char </span>
            <span className="qwerty-4">c</span>
              <span className="qwerty-3"> = </span>
            <span className="qwerty-10">Convert.</span>
            <span className="qwerty-3">ToChar</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"}
              <span className="qwerty-4">d</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">5,Boolean literals in c#:</h2>



<h2 className='headings'>Q-Boolean literal Check True or False in c# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-10">Boolean </span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty">true</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-10">Boolean </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-11">false</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-10">Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2"> + " " + </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-11">)</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-3">Or </span>
            {"\n"}
              <span className="qwerty-10">Boolean</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-2">,</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4">a</span>
            <span className="qwerty-2"> =</span>
            <span className="qwerty"> true</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4">b</span>
              <span className="qwerty-2"> = </span>
              <span className="qwerty-11">false</span>
              <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-10">Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-11">)</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-10">Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-11">)</span>
            <span className="qwerty-2">;</span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >
          {"\n"}
         
            <span className="qwerty-5">true</span>{"\n"}
            <span className="qwerty-2">false</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">true</span>
            {"\n"}
            <span className="qwerty">false</span>
            {"\n"}
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Null literals in c#</h2>
<p className="mt-4 para">Null literals are used to indicate that this object is not available more.</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-namespace">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csliteral;